import React, { useState } from "react";

const NEON = "#00FF99";

export default function ActionList({ list, onSelect, isPending }) {
  const [selectedId, setSelectedId] = useState(null);
  if (!list) return null;
  const items = list.items || [];

  const containerStyle = {
    background:    "rgba(0,0,0,0.2)",
    border:        "1px solid rgba(255,255,255,0.08)",
    borderRadius:  12,
    overflow:      "hidden",
    margin:        "8px 0",
    maxWidth:      340,
  };
  const headerStyle = {
    padding:        "10px 14px",
    fontSize:       12,
    color:          "rgba(255,255,255,0.4)",
    textTransform:  "uppercase",
    letterSpacing:  "0.5px",
    borderBottom:   "1px solid rgba(255,255,255,0.06)",
  };
  const itemBase = {
    display:        "flex",
    flexDirection:  "column",
    padding:        "10px 14px",
    cursor:         isPending ? "wait" : "pointer",
    borderBottom:   "1px solid rgba(255,255,255,0.04)",
    borderLeft:     "2px solid transparent",
    transition:     "background 0.15s, border-color 0.15s",
  };
  const labelStyle = {
    color:      "#fff",
    fontSize:   13,
    fontWeight: 500,
  };
  const sublabelStyle = {
    color:     "rgba(255,255,255,0.4)",
    fontSize:  11,
    marginTop: 2,
  };

  const handleClick = (item) => {
    if (isPending) return;
    setSelectedId(item.id);
    onSelect?.(item);
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>{list.title || "Choose one"}</div>
      {items.length === 0 ? (
        <div style={{ padding: "16px 14px", color: "rgba(255,255,255,0.3)", fontSize: 13 }}>
          Nothing to choose from.
        </div>
      ) : (
        items.map((item, i) => {
          const selected = item.id === selectedId;
          return (
            <div
              key={item.id || i}
              style={{
                ...itemBase,
                background:  selected ? "rgba(0,255,153,0.06)" : "transparent",
                borderLeftColor: selected ? NEON : "transparent",
              }}
              onMouseEnter={(e) => {
                if (isPending || selected) return;
                e.currentTarget.style.background = "rgba(0,255,153,0.06)";
              }}
              onMouseLeave={(e) => {
                if (isPending || selected) return;
                e.currentTarget.style.background = "transparent";
              }}
              onClick={() => handleClick(item)}
            >
              <span style={labelStyle}>{item.label}</span>
              {item.sublabel && <span style={sublabelStyle}>{item.sublabel}</span>}
            </div>
          );
        })
      )}
    </div>
  );
}
